
import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
// import { PrismEditor } from 'vue-prism-editor';
// import 'vue-prism-editor/dist/prismeditor.min.css';
// import Prism from "prismjs";

@Component({
	components: {
		// PrismEditor,
	}
})
export default class SettingFallback extends Vue
{
	@Prop(String) readonly settingsJsonString: string | undefined;
	@Prop(String) readonly title: string | undefined;

	code = "";

	parse()
	{
		console.log("SettingFallback:jsonstring", this.settingsJsonString);
		if(!this.settingsJsonString)
		{
			return;
		}

		this.code = this.settingsJsonString;
	}

	changed()
	{
		this.$emit("updated", this.title, this.code);
	}
	// highlighter(code: string)
	// {
	// 	return Prism.highlight(code, Prism.languages.json, "json");
	// }

	// updated()
	// {
	// 	this.parse();
	// }

	mounted()
	{
		this.parse();
	}
}
